import { Avatar, AvatarGender, AvatarType } from '@/types/avatar';
import { AI_SOURCES } from './api';

export const TAVUS_AVATARS: Avatar[] = [
  {
    id: 'r0f7e90793',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0f7e90793.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0f7e90793_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0f7e90793_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r0f7e90793',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'outdoor',
    },
    name: 'Destiny - Courtyard',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4949/1b9c5078.mp4',
    hardcoded: true,
  },
  {
    id: 'r1e69411f2',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1e69411f2.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1e69411f2_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1e69411f2_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1e69411f2',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue', 'white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Sabrina - Grey',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3552/1e735b41.mp4',
    hardcoded: true,
  },
  {
    id: 'r637dd0cdd',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r637dd0cdd.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r637dd0cdd_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r637dd0cdd_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r637dd0cdd',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['white', 'gray'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Gloria - Conversational',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3703/ff4822f2.mp4',
    hardcoded: true,
  },
  {
    id: 'r40f2da1a2',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r40f2da1a2.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r40f2da1a2_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r40f2da1a2_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r40f2da1a2',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Jennifer - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4263/3817f58e.mp4',
    hardcoded: true,
  },
  {
    id: 'r0104286ea',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0104286ea.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0104286ea_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0104286ea_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r0104286ea',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'gray'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Jimmy',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3666/ed41a2da.mp4',
    hardcoded: true,
  },
  {
    id: 'r054afacf7',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r054afacf7.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r054afacf7_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r054afacf7_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r054afacf7',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['red'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Leonardo',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3290/bb51941c.mp4',
    hardcoded: true,
  },
  {
    id: 'r067b795cc',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r067b795cc.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r067b795cc_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r067b795cc_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r067b795cc',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Calvin - Green',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4935/99199694.mp4',
    hardcoded: true,
  },
  {
    id: 'r084238898',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r084238898.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r084238898_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r084238898_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r084238898',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['black', 'brown'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Jackie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4454/869c3890.mp4',
    hardcoded: true,
  },
  {
    id: 'r094ecc9a5',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r094ecc9a5.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r094ecc9a5_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r094ecc9a5_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r094ecc9a5',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'business casual',
      clothingColorPalette: ['gray', 'white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Helen - Light Pink',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3622/bd0ad85e.mp4',
    hardcoded: true,
  },
  {
    id: 'r09d16d4b6',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r09d16d4b6.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r09d16d4b6_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r09d16d4b6_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r09d16d4b6',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Aaliyah',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3681/3c84a403.mp4',
    hardcoded: true,
  },
  {
    id: 'r0a8dd8762',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0a8dd87628f.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0a8dd87628f_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0a8dd87628f_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r0a8dd87628f',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['gray', 'white'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Helen - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8618/3b49c3bf.mp4',
    hardcoded: true,
  },
  {
    id: 'r1b15de50c',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1b15de50c.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1b15de50c_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1b15de50c_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1b15de50c',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Jennifer - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3051/37880a60.mp4',
    hardcoded: true,
  },
  {
    id: 'r105cfc41a',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r105cfc41a.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r105cfc41a_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r105cfc41a_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r105cfc41a',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Samantha',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4330/f4718dd3.mp4',
    hardcoded: true,
  },
  {
    id: 'r10e648bfa',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r10e648bfa.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r10e648bfa_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r10e648bfa_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r10e648bfa',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['red', 'black'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Victoria - Selfie 1',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/2912/e839476c.mp4',
    hardcoded: true,
  },
  {
    id: 'r0d055d4c5',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0d055d4c5.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0d055d4c5_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r0d055d4c5_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r0d055d4c5',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Gloria - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4183/0082e481.mp4',
    hardcoded: true,
  },
  {
    id: 'r1653e6e84',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1653e6e84ad.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1653e6e84ad_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1653e6e84ad_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1653e6e84ad',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['beige'],
      gender: AvatarGender.Female,
      background: 'other',
    },
    name: 'Lucy - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8562/11c1966a.mp4',
    hardcoded: true,
  },
  {
    id: 'r18d46c93e',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r18d46c93e.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r18d46c93e_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r18d46c93e_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r18d46c93e',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['pink'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Victoria - Selfie 2',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/2913/4f309123.mp4',
    hardcoded: true,
  },
  {
    id: 'r1a667ea75',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1a667ea75.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1a667ea75_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1a667ea75_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1a667ea75',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Anna - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3285/a914f42f.mp4',
    hardcoded: true,
  },

  {
    id: 'r1c6b90d34',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1c6b90d34.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1c6b90d34_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1c6b90d34_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1c6b90d34',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Nathan - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4179/8368b850.mp4',
    hardcoded: true,
  },
  {
    id: 'r1dbdb0241',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1dbdb02417a.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1dbdb02417a_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1dbdb02417a_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1dbdb02417a',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'other',
    },
    name: 'Anna - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8535/b1064109.mp4',
    hardcoded: true,
  },

  {
    id: 'r1fbfc941b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1fbfc941b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1fbfc941b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r1fbfc941b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r1fbfc941b',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'yellow'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Nathan',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3664/fe6ce0f9.mp4',
    hardcoded: true,
  },
  {
    id: 'r21027455f',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r21027455f.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r21027455f_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r21027455f_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r21027455f',
    metadata: {
      ageRange: '50-59',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Arjun - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4948/171fc9be.mp4',
    hardcoded: true,
  },
  {
    id: 'r243eed46c',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r243eed46c.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r243eed46c_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r243eed46c_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r243eed46c',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Steph',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4333/53ac97df.mp4',
    hardcoded: true,
  },
  {
    id: 'r250b2003c',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r250b2003c.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r250b2003c_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r250b2003c_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r250b2003c',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['red', 'black'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Devin - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/2394/e9635ac4.mp4',
    hardcoded: true,
  },
  {
    id: 'r2731127d5',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2731127d5.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2731127d5_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2731127d5_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r2731127d5',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['pink', 'white'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Robert - Office 2',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3547/61af8c4b.mp4',
    hardcoded: true,
  },
  {
    id: 'r2b021a590',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2b021a590.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2b021a590_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2b021a590_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r2b021a590',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'business casual',
      clothingColorPalette: ['gray', 'white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Helen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3287/465568de.mp4',
    hardcoded: true,
  },
  {
    id: 'r2bdbdd931',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2bdbdd931.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2bdbdd931_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r2bdbdd931_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r2bdbdd931',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Diego - Office 2',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3289/4ace8eb1.mp4',
    hardcoded: true,
  },
  {
    id: 'r315bff4de',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r315bff4de.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r315bff4de_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r315bff4de_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r315bff4de',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Victoria - White',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3056/c2eab98d.mp4',
    hardcoded: true,
  },
  {
    id: 'r336b27aff',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r336b27aff.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r336b27aff_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r336b27aff_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r336b27aff',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'business casual',
      clothingColorPalette: ['gray', 'white'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Helen - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3554/b7ebe51e.mp4',
    hardcoded: true,
  },
  {
    id: 'r393c989e2',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r393c989e2.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r393c989e2_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r393c989e2_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r393c989e2',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Scott - Grey',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4929/94406d29.mp4',
    hardcoded: true,
  },
  {
    id: 'r3a5283365',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3a5283365.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3a5283365_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3a5283365_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r3a5283365',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Kenneth - Lobby',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4665/cc959184.mp4',
    hardcoded: true,
  },
  {
    id: 'r3b3c4f911',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3b3c4f911.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3b3c4f911_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3b3c4f911_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r3b3c4f911',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'indoor',
    },
    name: 'Andre',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4336/575c1a96.mp4',
    hardcoded: true,
  },
  {
    id: 'r3fbe3834a',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3fbe3834a3e.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3fbe3834a3e_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r3fbe3834a3e_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r3fbe3834a3e',
    metadata: {
      ageRange: '60+',
      clothingStyle: 'traditional',
      clothingColorPalette: ['red', 'white'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Santa',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/9908/bea23676.mp4',
    hardcoded: true,
  },
  {
    id: 'r40ee7e29b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r40ee7e29b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r40ee7e29b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r40ee7e29b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r40ee7e29b',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['pink', 'beige'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Reyna',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4456/4b1c2e6d.mp4',
    hardcoded: true,
  },

  {
    id: 'r41c3031c1',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r41c3031c1.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r41c3031c1_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r41c3031c1_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r41c3031c1',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['pink'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Robert - Kitchen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3549/deb13206.mp4',
    hardcoded: true,
  },
  {
    id: 'r4249d7154',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4249d7154.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4249d7154_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4249d7154_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4249d7154',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Steve - Purple',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4933/9ae3df9d.mp4',
    hardcoded: true,
  },
  {
    id: 'r43d31a795',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r43d31a795.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r43d31a795_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r43d31a795_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r43d31a795',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Gloria - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4668/11646a7d.mp4',
    hardcoded: true,
  },
  {
    id: 'r43f5154d6',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r43f5154d6.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r43f5154d6_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r43f5154d6_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r43f5154d6',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue', 'white'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Sabrina - Home Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3551/745e66d0.mp4',
    hardcoded: true,
  },
  {
    id: 'r445a7952e',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r445a7952e.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r445a7952e_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r445a7952e_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r445a7952e',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['green'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Bailey',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4334/4f22dc05.mp4',
    hardcoded: true,
  },
  {
    id: 'r492a86a1f',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r492a86a1f2d.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r492a86a1f2d_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r492a86a1f2d_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r492a86a1f2d',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'other',
    },
    name: 'Eric - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8571/c8a03ff5.mp4',
    hardcoded: true,
  },
  {
    id: 'r49f0f6270',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r49f0f6270.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r49f0f6270_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r49f0f6270_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r49f0f6270',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Eric ',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3373/96d2b395.mp4',
    hardcoded: true,
  },
  {
    id: 'r4c13091db',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4c13091db.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4c13091db_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4c13091db_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4c13091db',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Anna - Office 2',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3556/e25a6281.mp4',
    hardcoded: true,
  },
  {
    id: 'r4c41453d2',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4c41453d2.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4c41453d2_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4c41453d2_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4c41453d2',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white', 'pink'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Anna',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4699/5f8e8f8d.mp4',
    hardcoded: true,
  },
  {
    id: 'r4da784871',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4da784871.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4da784871_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4da784871_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4da784871',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'outdoor',
    },
    name: 'Sandra - Outdoor Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3055/4eaf61cb.mp4',
    hardcoded: true,
  },
  {
    id: 'r4e34d2d67',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4e34d2d67.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4e34d2d67_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4e34d2d67_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4e34d2d67',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['red', 'white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Sandra - Laptop',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4260/404e9bdc.mp4',
    hardcoded: true,
  },
  {
    id: 'r4e401136b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4e401136b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4e401136b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4e401136b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4e401136b',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Jimmy - Blue',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4659/1669c33c.mp4',
    hardcoded: true,
  },
  {
    id: 'r4f6470a95',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4f6470a95.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4f6470a95_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r4f6470a95_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r4f6470a95',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Calvin - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4669/704601bd.mp4',
    hardcoded: true,
  },
  {
    id: 'r501f59140',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r501f5914091.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r501f5914091_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r501f5914091_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r501f5914091',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Steve - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8563/0ec19b0d.mp4',
    hardcoded: true,
  },
  {
    id: 'r51cb5ea70',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r51cb5ea70.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r51cb5ea70_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r51cb5ea70_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r51cb5ea70',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Nathan - Blue',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4656/a054996f.mp4',
    hardcoded: true,
  },
  {
    id: 'r52da2535a',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r52da2535a.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r52da2535a_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r52da2535a_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r52da2535a',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['maroon'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Laura - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4993/b2fd1e0e.mp4',
    hardcoded: true,
  },
  {
    id: 'r590584193',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r590584193.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r590584193_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r590584193_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r590584193',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'other',
    },
    name: 'Scott - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4688/fc9b9f8b.mp4',
    hardcoded: true,
  },
  {
    id: 'r594c6a4aa',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r594c6a4aa.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r594c6a4aa_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r594c6a4aa_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r594c6a4aa',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Eric - Aqua ',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3296/468b5e95.mp4',
    hardcoded: true,
  },
  {
    id: 'r5a10b33be',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5a10b33be.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5a10b33be_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5a10b33be_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r5a10b33be',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Patrick - Green',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4930/adb79359.mp4',
    hardcoded: true,
  },
  {
    id: 'r5b3265ee1',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5b3265ee1.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5b3265ee1_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5b3265ee1_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r5b3265ee1',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Destiny - Red',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4658/7c3ddc24.mp4',
    hardcoded: true,
  },
  {
    id: 'r5c5d0370b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5c5d0370b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5c5d0370b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r5c5d0370b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r5c5d0370b',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Male,
      background: 'outdoor',
    },
    name: 'Diego',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4331/ebe9486f.mp4',
    hardcoded: true,
  },
  {
    id: 'r604520422',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r604520422.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r604520422_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r604520422_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r604520422',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Lucy - Gold',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4664/1d90108f.mp4',
    hardcoded: true,
  },
  {
    id: 'r605415625',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r605415625.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r605415625_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r605415625_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r605415625',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Nathan - Home Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4946/3d079ed6.mp4',
    hardcoded: true,
  },

  {
    id: 'r638794ceb',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r638794ceb2a.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r638794ceb2a_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r638794ceb2a_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r638794ceb2a',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Calvin - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8559/70df18e1.mp4',
    hardcoded: true,
  },
  {
    id: 'r63f390d9b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r63f390d9b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r63f390d9b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r63f390d9b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r63f390d9b',
    metadata: {
      ageRange: '50-59',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'outdoor',
    },
    name: 'Arjun - Courtyard',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4947/d18195d2.mp4',
    hardcoded: true,
  },
  {
    id: 'r654493d9e',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r654493d9e.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r654493d9e_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r654493d9e_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r654493d9e',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'other',
    },
    name: 'Alice - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4662/d0323450.mp4',
    hardcoded: true,
  },
  {
    id: 'r6583a465c',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6583a465c.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6583a465c_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6583a465c_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r6583a465c',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue', 'red'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Nathan - Bookshelf',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/5457/35d9addc.mp4',
    hardcoded: true,
  },
  {
    id: 'r660c4f3ba',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r660c4f3ba.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r660c4f3ba_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r660c4f3ba_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r660c4f3ba',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['red'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Laura',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4350/04f62bad.mp4',
    hardcoded: true,
  },
  {
    id: 'r694955199',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r694955199.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r694955199_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r694955199_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r694955199',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'formal',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Diego - Office 3',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3254/59b9d8a7.mp4',
    hardcoded: true,
  },
  {
    id: 'r6b7318f8d',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6b7318f8d.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6b7318f8d_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6b7318f8d_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r6b7318f8d',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Patrick',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3649/68b4d40c.mp4',
    hardcoded: true,
  },
  {
    id: 'r6c3cc3111',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6c3cc3111.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6c3cc3111_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6c3cc3111_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r6c3cc3111',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Patrick - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4716/d854ca8d.mp4',
    hardcoded: true,
  },
  {
    id: 'r6d479c214',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6d479c214.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6d479c214_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6d479c214_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r6d479c214',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'red'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Devin - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4261/191381ce.mp4',
    hardcoded: true,
  },
  {
    id: 'r6e055828f',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6e055828f63.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6e055828f63_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6e055828f63_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r6e055828f63',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Gloria - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8565/f356dc4c.mp4',
    hardcoded: true,
  },
  {
    id: 'r6f41becb2',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6f41becb2.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6f41becb2_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r6f41becb2_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r6f41becb2',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['black', 'brown'],
      gender: AvatarGender.Female,
      background: 'indoor',
    },
    name: 'Jackie - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4256/70b63fc8.mp4',
    hardcoded: true,
  },
  {
    id: 'r70c6bc650',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r70c6bc650af.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r70c6bc650af_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r70c6bc650af_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r70c6bc650af',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white', 'brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Diego - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8533/ebdcabd9.mp4',
    hardcoded: true,
  },
  {
    id: 'r70f15c5b1',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r70f15c5b1.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r70f15c5b1_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r70f15c5b1_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r70f15c5b1',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['pink'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Robert',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3250/fd78b655.mp4',
    hardcoded: true,
  },
  {
    id: 'r718bd0f1b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r718bd0f1b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r718bd0f1b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r718bd0f1b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r718bd0f1b',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Scott - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4001/341c1752.mp4',
    hardcoded: true,
  },
  {
    id: 'r725beda81',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r725beda81.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r725beda81_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r725beda81_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r725beda81',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['beige'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Lucy - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4952/f2278aba.mp4',
    hardcoded: true,
  },
  {
    id: 'r74c734ddc',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r74c734ddc.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r74c734ddc_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r74c734ddc_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r74c734ddc',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'gray'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Antonio - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3076/0aef70e6.mp4',
    hardcoded: true,
  },
  {
    id: 'r74df1ac87',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r74df1ac87.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r74df1ac87_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r74df1ac87_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r74df1ac87',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Aaliyah - Purple',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4689/7ed4e71d.mp4',
    hardcoded: true,
  },
  {
    id: 'r767d40a50',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r767d40a50.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r767d40a50_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r767d40a50_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r767d40a50',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue', 'gray'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Scott',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3661/8bb4175c.mp4',
    hardcoded: true,
  },
  {
    id: 'r79e1c033f',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r79e1c033f.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r79e1c033f_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r79e1c033f_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r79e1c033f',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'yellow'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Nathan - Conference Room',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4967/b93cfa96.mp4',
    hardcoded: true,
  },
  {
    id: 'r7dbef2aab',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r7dbef2aab.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r7dbef2aab_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r7dbef2aab_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r7dbef2aab',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'white'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Steph - Laptop 1',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4259/5f750289.mp4',
    hardcoded: true,
  },
  {
    id: 'r86661906c',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r86661906c.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r86661906c_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r86661906c_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r86661906c',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Andre - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3609/fce1aefa.mp4',
    hardcoded: true,
  },
  {
    id: 'r87e8afa7d',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r87e8afa7d.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r87e8afa7d_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r87e8afa7d_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r87e8afa7d',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Kenneth - Green',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4932/74af0c91.mp4',
    hardcoded: true,
  },
  {
    id: 'r89329f4fd',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r89329f4fd.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r89329f4fd_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r89329f4fd_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r89329f4fd',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Female,
      background: 'other',
    },
    name: 'Sandra - Car Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3053/b16160b0.mp4',
    hardcoded: true,
  },
  {
    id: 'r8bb0646ae',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8bb0646ae.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8bb0646ae_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8bb0646ae_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r8bb0646ae',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['grey', 'black'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Kenneth',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3636/0e8c302c.mp4',
    hardcoded: true,
  },
  {
    id: 'r8bfa69a42',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8bfa69a42.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8bfa69a42_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8bfa69a42_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r8bfa69a42',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['red'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Laura - Pink',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4453/de52f9ea.mp4',
    hardcoded: true,
  },
  {
    id: 'r8e839ebb6',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8e839ebb6.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8e839ebb6_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r8e839ebb6_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r8e839ebb6',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Bailey - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4257/3a509d73.mp4',
    hardcoded: true,
  },
  {
    id: 'r9191662c8',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9191662c8.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9191662c8_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9191662c8_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r9191662c8',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['pink'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Celine - Home Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4663/38a621da.mp4',
    hardcoded: true,
  },
  {
    id: 'r9247bcb15',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9247bcb15.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9247bcb15_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9247bcb15_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r9247bcb15',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'business casual',
      clothingColorPalette: ['black', 'gray'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'David',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4351/ac4b67fb.mp4',
    hardcoded: true,
  },
  {
    id: 'r934c980b4',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r934c980b4.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r934c980b4_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r934c980b4_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r934c980b4',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white', 'brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Diego - Blue',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3253/cac059e7.mp4',
  },
  {
    id: 'r93bd4e488',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r93bd4e488.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r93bd4e488_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r93bd4e488_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r93bd4e488',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['beige', 'white'],
      gender: AvatarGender.Female,
      background: 'indoor',
    },
    name: 'Isabella - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3177/63ce3560.mp4',
    hardcoded: true,
  },
  {
    id: 'r978d29eb2',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r978d29eb2.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r978d29eb2_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r978d29eb2_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r978d29eb2',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Leonardo - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3298/434ffc72.mp4',
    hardcoded: true,
  },
  {
    id: 'r9cdea0314',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9cdea0314.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9cdea0314_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9cdea0314_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r9cdea0314',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Lucy - Office - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4106/07781875.mp4',
    hardcoded: true,
  },
  {
    id: 'r9d2a7a53c',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9d2a7a53c.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9d2a7a53c_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/r9d2a7a53c_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'r9d2a7a53c',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'other',
    },
    name: 'Eric - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3546/9c9c5f0b.mp4',
    hardcoded: true,
  },
  {
    id: 'ra0322b20e',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra0322b20e.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra0322b20e_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra0322b20e_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'ra0322b20e',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white', 'red'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Natasha',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3608/35d7ae04.mp4',
    hardcoded: true,
  },
  {
    id: 'ra54d1d861',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra54d1d861.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra54d1d861_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra54d1d861_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'ra54d1d861',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue', 'white'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Lucy',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3638/576838aa.mp4',
    hardcoded: true,
  },
  {
    id: 'ra5e60eeb0',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra5e60eeb07f.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra5e60eeb07f_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra5e60eeb07f_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'ra5e60eeb07f',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['maroon'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Leonardo - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8574/7b05283f.mp4',
    hardcoded: true,
  },
  {
    id: 'ra8f6684f6',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra8f6684f6d1.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra8f6684f6d1_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ra8f6684f6d1_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'ra8f6684f6d1',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue', 'white'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Sophie - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8572/d92d2b25.mp4',
    hardcoded: true,
  },
  {
    id: 'rab1105513',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rab1105513.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rab1105513_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rab1105513_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rab1105513',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Alice - Mauve',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4931/be9798fc.mp4',
    hardcoded: true,
  },
  {
    id: 'rab615a199',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rab615a199.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rab615a199_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rab615a199_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rab615a199',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['pink', 'black'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Aaliyah - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4985/fcab1cc5.mp4',
    hardcoded: true,
  },
  {
    id: 'rae3207700',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rae3207700.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rae3207700_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rae3207700_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rae3207700',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['beige'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Jimmy - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4951/78cf4a38.mp4',
    hardcoded: true,
  },
  {
    id: 'rb2606b718',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb2606b71887.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb2606b71887_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb2606b71887_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rb2606b71887',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['pink'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Celine - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8560/4186db35.mp4',
    hardcoded: true,
  },
  {
    id: 'rb508541fb',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb508541fb.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb508541fb_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb508541fb_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rb508541fb',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['maroon'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Leonardo - Beige',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3470/4e5ac85c.mp4',
    hardcoded: true,
  },
  {
    id: 'rb8a2b77cb',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb8a2b77cb.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb8a2b77cb_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rb8a2b77cb_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rb8a2b77cb',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Destiny',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4306/bda18a2c.mp4',
    hardcoded: true,
  },
  {
    id: 'rbb0f535dd',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbb0f535dd.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbb0f535dd_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbb0f535dd_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rbb0f535dd',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Gloria',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3640/485a0e9d.mp4',
    hardcoded: true,
  },
  {
    id: 'rbcf469f0a',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbcf469f0a.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbcf469f0a_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbcf469f0a_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rbcf469f0a',
    metadata: {
      ageRange: '50-59',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Arjun - Office - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4060/cc9076b1.mp4',
    hardcoded: true,
  },
  {
    id: 'rbedfcceb3',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbedfcceb3.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbedfcceb3_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbedfcceb3_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rbedfcceb3',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['maroon'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Leonardo - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3471/f75ad47d.mp4',
    hardcoded: true,
  },
  {
    id: 'rbff6415e6',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbff6415e6.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbff6415e6_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rbff6415e6_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rbff6415e6',
    metadata: {
      ageRange: '50-59',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Arjun - Grey',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4657/6f582a03.mp4',
    hardcoded: true,
  },
  {
    id: 'rc46b5d772',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rc46b5d772.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rc46b5d772_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rc46b5d772_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rc46b5d772',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Victoria - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3057/75a1e38e.mp4',
    hardcoded: true,
  },
  {
    id: 'rc5ab5fe34',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rc5ab5fe34.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rc5ab5fe34_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rc5ab5fe34_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rc5ab5fe34',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Jennifer - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/2379/caf75f77.mp4',
    hardcoded: true,
  },
  {
    id: 'rca5e9b9dc',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rca5e9b9dc.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rca5e9b9dc_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rca5e9b9dc_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rca5e9b9dc',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Female,
      background: 'office',
    },
    name: 'Sandra - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4258/2cd622b1.mp4',
    hardcoded: true,
  },
  {
    id: 'rce846fcf7',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rce846fcf7.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rce846fcf7_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rce846fcf7_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rce846fcf7',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Steph - Selfie',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/2049/2bc7d0a3.mp4',
    hardcoded: true,
  },
  {
    id: 'rceacec30f',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rceacec30f.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rceacec30f_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rceacec30f_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rceacec30f',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue', 'gray'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Gloria - Orange',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4934/a3d3bb9e.mp4',
    hardcoded: true,
  },
  {
    id: 'rd1b92a099',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rd1b92a0999a.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rd1b92a0999a_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rd1b92a0999a_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rd1b92a0999a',
    metadata: {
      ageRange: '50-59',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'outdoor',
    },
    name: 'Guru - Vertical',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/8561/5301baea.mp4',
    hardcoded: true,
  },
  {
    id: 'rd4e6981aa',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rd4e6981aa.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rd4e6981aa_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rd4e6981aa_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rd4e6981aa',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'casual',
      clothingColorPalette: ['gray'],
      gender: AvatarGender.Male,
      background: 'indoor',
    },
    name: 'Steve - Lobby',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4666/a7633679.mp4',
    hardcoded: true,
  },
  {
    id: 'rde3b1a18f',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rde3b1a18f.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rde3b1a18f_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rde3b1a18f_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rde3b1a18f',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue', 'pink'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Diego - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3606/0f78c1dc.mp4',
    hardcoded: true,
  },
  {
    id: 're008a6ea6',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re008a6ea6.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re008a6ea6_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re008a6ea6_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 're008a6ea6',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Destiny - Home Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4950/244455c4.mp4',
    hardcoded: true,
  },
  {
    id: 're602baff7',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re602baff7.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re602baff7_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re602baff7_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 're602baff7',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['blue'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Alice',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3702/40815bd8.mp4',
    hardcoded: true,
  },
  {
    id: 're8e740a42',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re8e740a42.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re8e740a42_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/re8e740a42_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 're8e740a42',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black', 'yellow'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Nathan - Demo',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3690/8436f23c.mp4',
    hardcoded: true,
  },
  {
    id: 'red5e2da4b',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/red5e2da4b.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/red5e2da4b_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/red5e2da4b_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'red5e2da4b',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Kenneth - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4110/c5321337.mp4',
    hardcoded: true,
  },
  {
    id: 'ref226fe7e',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ref226fe7e.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ref226fe7e_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ref226fe7e_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'ref226fe7e',
    metadata: {
      ageRange: '40-49',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Steve',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3639/6775954a.mp4',
    hardcoded: true,
  },
  {
    id: 'ref9611c10',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ref9611c10.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ref9611c10_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/ref9611c10_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'ref9611c10',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['pink'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Celine - Blue',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/4928/9c40a109.mp4',
    hardcoded: true,
  },
  {
    id: 'rf352e0da3',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf352e0da3.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf352e0da3_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf352e0da3_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rf352e0da3',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'studio',
    },
    name: 'Eric - Green Screen',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3295/1a0b7e95.mp4',
    hardcoded: true,
  },
  {
    id: 'rf725707a5',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf725707a5.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf725707a5_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf725707a5_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rf725707a5',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['white'],
      gender: AvatarGender.Female,
      background: 'studio',
    },
    name: 'Anna - Office',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3165/74d49abc.mp4',
    hardcoded: true,
  },
  {
    id: 'rf8142b7f0',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf8142b7f0.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf8142b7f0_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rf8142b7f0_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rf8142b7f0',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'casual',
      clothingColorPalette: ['black'],
      gender: AvatarGender.Male,
      background: 'office',
    },
    name: 'Jason',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3607/015aba41.mp4',
    hardcoded: true,
  },
  {
    id: 'rfb51183fe',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rfb51183fe.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rfb51183fe_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rfb51183fe_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rfb51183fe',
    metadata: {
      ageRange: '30-39',
      clothingStyle: 'business casual',
      clothingColorPalette: ['blue', 'gray'],
      gender: AvatarGender.Female,
      background: 'home',
    },
    name: 'Celine',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3631/21714c97.mp4',
  },
  {
    id: 'rfd03e9ebc',
    src: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rfd03e9ebc.jpg',
    sources: {
      no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rfd03e9ebc_no_bg.png',
      video_preview_no_bg: 'https://videos.gotolstoy.com/assets/tavus/replica-thumbnails/rfd03e9ebc_no_bg.gif',
    },
    fullscreenFit: { type: 'cover' },
    circleFit: { type: 'cover' },
    source: AI_SOURCES.tavus,
    approvedForAds: true,
    type: AvatarType.Default,
    avatarId: 'rfd03e9ebc',
    metadata: {
      ageRange: '20-29',
      clothingStyle: 'casual',
      clothingColorPalette: ['brown'],
      gender: AvatarGender.Male,
      background: 'home',
    },
    name: 'Calvin',
    videoPreviewSrc: 'https://cdn.replica.tavus.io/3679/cbdc4c99.mp4',
    hardcoded: true,
  },
];
